(function () {
  function syncMenuState() {
    var nav = document.getElementById('mobile-nav');
    document.documentElement.classList.toggle('aeliza-mobile-menu-open', !!(nav && nav.classList.contains('is-open')));
  }

  function init() {
    var toggle = document.getElementById('mobile-menu-toggle');
    var nav = document.getElementById('mobile-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      window.requestAnimationFrame(syncMenuState);
    });

    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        document.documentElement.classList.remove('aeliza-mobile-menu-open');
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) {
        document.documentElement.classList.remove('aeliza-mobile-menu-open');
      } else {
        syncMenuState();
      }
    });

    syncMenuState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
